


<editor
  [(ngModel)]="value"
  (ngModelChange)="onChange($event)"
  [init]="{
    base_url: '/tinymce',
    suffix: '.min',

    plugins: 'autolink link image fullscreen lists table quickbars searchreplace wordcount charmap code',

    toolbar: 'undo redo | blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | outdent indent | link image | table | searchreplace | removeformat | code | fullscreen',

    menubar: 'file edit view insert format tools table help',
    toolbar_mode: 'sliding',
    contextmenu: 'link image table',

    quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote',
    quickbars_insert_toolbar: 'quickimage quicktable',

    table_default_attributes: { border: '1' },
    table_default_styles: { width: '100%' },

    file_picker_callback: openFileManagerWrapper
  }"
></editor>

<ng-template #fileManagerModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">ფაილის არჩევა</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <app-file-manager
      [type]="'image'"
      (fileSelected)="onFileSelected($event)">
    </app-file-manager>
  </div>
</ng-template>